import MenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';

export const DropDownSelectItem = styled(MenuItem)<MenuItemProps>(() => ({
    // padding: '0px',
}));
